import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsFloor from "graphql/fields/FieldsFloor";
import FieldsRoom from "graphql/fields/FieldsRoom";
import FieldsTimeslot from 'graphql/fields/FieldsTimeslot'

const fields = {
	'guid': 'String!',
};

export default gql(`
	query floor( ${ HelperGraphql.createFields( fields ) } ) {
		floor( ${ HelperGraphql.createVariables( fields ) } ) {
			${FieldsFloor}
			
			building {
				guid
			}
			
			rooms {
				${FieldsRoom}
			}
			
			timeslots {
				timeslot {
					${FieldsTimeslot}
				}
			}
			
		    available_for_teams {
	            team {
	                guid
	                name
	            }
	        }
			
		    available_for_employees {
	            employee {
	                guid
	                name
	                department{
						name
					}
					team{
						name
					}
	            }
	        }
		}
	}
`);

